import React from "react";
import ReactQuill from "react-quill-new";
import { convertHtmlToDelta, convertTextToDelta } from "quill-converter";
import styles from "./styles.module.scss";
import "react-quill-new/dist/quill.snow.css";

const QuillDisplay = ({ deltaContent }) => {
  let parsedDelta;

  try {
    parsedDelta = JSON.parse(deltaContent);
    if (!parsedDelta.ops) {
      throw new Error("Invalid Delta");
    }
  } catch {
    if (/<[^>]*>/g.test(deltaContent)) {
      parsedDelta = convertHtmlToDelta(deltaContent);
    } else {
      parsedDelta = convertTextToDelta(deltaContent);
    }
  }

  return (
    <div className={styles.quillDisplayContainer}>
      <ReactQuill
        theme={"snow"}
        value={parsedDelta}
        readOnly={true}
        modules={{ toolbar: false }}
      >
        <div className={"border-0"}></div>
      </ReactQuill>
    </div>
  );
};

export default QuillDisplay;
